// extracted by mini-css-extract-plugin
module.exports = {"headerTab":"UNc69","highlighter":"yYwey","hide":"Tvfl0","tabList":"bGRFp","active":"AaOcE","moreMenuDots":"KcpPn","dots":"Di0Yi","moreMenuItems":"wWbZw"};